import React from "react";
import { ClipLoader } from "react-spinners";

interface ButtonLoaderProps {
  isBtnLoading: boolean,
  btnText: string
}

const ButtonLoader = (props: ButtonLoaderProps) => {
  const { isBtnLoading, btnText } = props;
  return (
    <>
      {isBtnLoading ? (
        <>
          <ClipLoader color="#fff" loading={isBtnLoading} size={15} />
          <span
            style={{
              marginLeft: "8px",
              fontSize: "15px",
              textAlign: "center",
            }}
          >
            Loading...
          </span>
        </>
      ) : (
        btnText
      )}
    </>
  );
};

export default ButtonLoader;
